import methods from './methods'
import props from './props'

export default {
  props,
  methods
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/favorite/resources/index.js